export const PLANS = {
  NOW: 'FitNow',
  PREDICTION: 'FitPred',
  OPTIMIZED: 'FitOptimize',
}
